<template>
  <HeaderView class="app-header-widget">
    <HeaderBlock
      :is-main-menu-open="isMobileMenuOpen"
      @mobile-menu-toggle="$emit('mobile-menu-toggle', $event)"
      @update-window-size="$emit('header-resize', $event)"
    />
    <WithdrawalMoneyRequestPopup
      ref="withdrawalPopup"
    />
  </HeaderView>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderBlock from './header';
import HeaderView from './header-view';
import { WITHDRAWAL_MONEY_REQUEST_POPUP_EVENTS, WithdrawalMoneyRequestPopup } from '@/features/withdrawal-money-request';

export default {
  props: {
    isMobileMenuOpen: {
      type: Boolean,
      required: true,
    },
  },
  created() {
    this.$eventBus.$on(WITHDRAWAL_MONEY_REQUEST_POPUP_EVENTS.OPEN, () => this.$refs.withdrawalPopup.open());
  },
  beforeDestroy() {
    this.$eventBus.$off(WITHDRAWAL_MONEY_REQUEST_POPUP_EVENTS.OPEN, () => this.$refs.withdrawalPopup.open());
  },
  components: { WithdrawalMoneyRequestPopup, HeaderView, HeaderBlock },
  computed: {
    ...mapGetters('layoutModule', ['isDesktop']),
  }
};
</script>

<style lang="scss" scoped>
.app-header-widget {
  font-family: 'Geist', sans-serif;
  font-size: 14px;
  color: #09090B;
}
</style>
